import React from 'react';
import {Navigate, useLocation, useParams} from 'react-router'
import {useSelector} from 'react-redux';

function AnyAuthRoute({component: Component, ...rest}) {
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const isAgency = useSelector(state => state.agency.isAuthenticated);

    const location = useLocation();
    const params = useParams();
    
    if (!isAuthenticated && !isAgency) {
        return <Navigate to="/login" replace />;
    }

    return <Component {...rest} location={location} params={params} />;
}

export default AnyAuthRoute;